import React, { useState, useEffect } from "react";
import HelperClass from "./../../config/helperClass";
import { THEME_COLOR } from "./../../config/config";
import { getPrivateIntegration } from "../../config/client_api_calls";
import $ from "jquery";
import { Button } from "react-bootstrap";
import CryptoJS from "crypto-js";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import { axiosConfig } from "./../../config/utility";
import axios from "axios";
const auth = new HelperClass();

export default function Header(props) {
  // function profileView() {
  //   window.$("#modalForm").modal("show");
  // }

  const [integrations, setIntegrations] = useState([]);
  const [integrationLoader, setIntegrationLoader] = useState(true);

  const [timeLeft, setTimeLeft] = useState(null);
  const [showExpiryModal, setShowExpiryModal] = useState(false);
  const [sessionExtended, setSessionExtended] = useState(false);

  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isExtending, setIsExtending] = useState(false);

  const [integrationInfo, setIntegrationInfo] = useState([]);
  const [parentIntegration, setParentIntegration] = useState([]);
  const [voicePermissionAdmin, setVoicePermissionAdmin] = useState("");
  const [clientData, setClientData] = useState([]);

  const getDecryptedCookie = (cookieName) => {
    const encryptedData = Cookies.get(cookieName);
    if (!encryptedData) return null;

    try {
      const decryptedBytes = CryptoJS.AES.decrypt(
        encryptedData,
        process.env.REACT_APP_SIGNATURE,
      );
      return decryptedBytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error(`Error decrypting ${cookieName}:`, error);
      return null;
    }
  };

  // Format time for display
  const formatTime = (milliseconds) => {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    if (hours > 0) {
      return `${hours}h ${minutes}m ${seconds}s`;
    } else if (minutes > 0) {
      return `${minutes}m ${seconds}s`;
    } else {
      return `${seconds}s`;
    }
  };

  // Extend session function
  const extendSession = async () => {
    setIsExtending(true); // Start loading
    setErrorMessage(""); // Clear any previous errors
    setSuccessMessage(""); // Clear any previous success messages

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}clients/refresh-token`,
        JSON.stringify({
          user_token: auth.getToken(),
          token: process.env.REACT_APP_API_TOKEN,
          api_accountno: process.env.REACT_APP_API_ACCOUNTNO,
        }),
        axiosConfig,
      );

      //console.log("response: ", response);

      if (response.data.status === 200) {
        // Update token and session times
        const decodedToken = jwtDecode(response.data.token);
        const newExpiryTime = decodedToken.exp * 1000; // Convert to milliseconds
        const currentTime = new Date().getTime();

        // Update cookies with new token and times
        Cookies.set(
          "client_tkn__",
          CryptoJS.AES.encrypt(
            response.data.token,
            process.env.REACT_APP_SIGNATURE,
          ).toString(),
        );

        Cookies.set(
          "client_session_start__",
          CryptoJS.AES.encrypt(
            currentTime.toString(),
            process.env.REACT_APP_SIGNATURE,
          ).toString(),
        );

        Cookies.set(
          "client_session_expiry__",
          CryptoJS.AES.encrypt(
            newExpiryTime.toString(),
            process.env.REACT_APP_SIGNATURE,
          ).toString(),
        );

        setSessionExtended(true);
        setSuccessMessage("Session extended successfully!");
        setErrorMessage("");

        // Close modal after 3 seconds
        setTimeout(() => {
          setSuccessMessage("");
          setShowExpiryModal(false);
        }, 3000);
      } else {
        setErrorMessage("Failed to extend session. Please try again.");
      }
    } catch (error) {
      console.error("Error extending session:", error);
      setErrorMessage(
        "Network error. Please check your connection and try again.",
      );
    } finally {
      setIsExtending(false); // Stop loading in both success and error cases
    }
  };

  useEffect(() => {
    const updateTimer = () => {
      const sessionExpiry = getDecryptedCookie("client_session_expiry__");

      if (!sessionExpiry) {
        setTimeLeft(null);
        return;
      }

      const expiryTime = parseInt(sessionExpiry);
      const currentTime = new Date().getTime();
      const remainingTime = expiryTime - currentTime;

      if (remainingTime <= 0) {
        // Session expired
        setTimeLeft(0);
        auth.logout(true);
        return;
      }

      setTimeLeft(remainingTime);

      // Show modal 10 minutes before expiry
      const tenMinutes = 10 * 60 * 1000;
      if (
        remainingTime <= tenMinutes &&
        !sessionExtended &&
        !localStorage.getItem("modalClosedManually")
      ) {
        setShowExpiryModal(true);
      }
    };

    // Update immediately
    updateTimer();

    // Update every second
    const timer = setInterval(updateTimer, 1000);

    return () => clearInterval(timer);
  }, [showExpiryModal, sessionExtended]);

  // Reset sessionExtended flag when session is actually extended
  useEffect(() => {
    if (sessionExtended) {
      const resetTimer = setTimeout(() => {
        setSessionExtended(false);
      }, 5000); // Reset after 5 seconds

      return () => clearTimeout(resetTimer);
    }
  }, [sessionExtended]);

  const handleCloseModal = () => {
    setShowExpiryModal(false);
    localStorage.setItem("modalClosedManually", "true");
  };

  const handleModalBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      setShowExpiryModal(false);
    }
  };

  useEffect(() => {
    getPrivateIntegrations();
  }, []);

  const getPrivateIntegrations = async () => {
    try {
      setIntegrationLoader(true);
      const getIntegrations_res = await getPrivateIntegration(
        auth.getAccount(),
        auth.getToken(),
      );
      // console.log("getIntegrations_res: ", getIntegrations_res.data);

      if (getIntegrations_res.data.status === 200) {
        setIntegrations(getIntegrations_res.data.data || []);
        setParentIntegration(getIntegrations_res.data.parentIntegration || []);
        setVoicePermissionAdmin(
          getIntegrations_res.data.voicePermissionAdmin || [],
        );
        setIntegrationInfo(getIntegrations_res.data.integrationInfo || []);
        setClientData(getIntegrations_res.data.clientInfo || []);
      } else {
        // console.log("No integrations found");
        setIntegrations([]);
        setParentIntegration([]);
        setVoicePermissionAdmin([]);
        setIntegrationInfo([]);
      }
      setIntegrationLoader(false);
    } catch (error) {
      console.error("Error fetching integrations:", error);
      setIntegrations([]);
      setParentIntegration([]);
      setVoicePermissionAdmin([]);
      setIntegrationInfo([]);
      setIntegrationLoader(false);
    }
  };

  function classCheck() {
    var menu_items = $(".nk-sidebar");
    if (menu_items.hasClass("nk-sidebar-active")) {
    } else {
      $(".nk-sidebar").addClass("nk-sidebar-active");
    }
  }
  //console.log("Header props: ", props);
  function accountActivity() {
    props.mainProps.history.push(
      "/" + auth.getResellerRegToken() + "/client/AccountActivity",
    );
  }

  function contact_agent() {
    window.$("#modalContactAgent").modal("show");
  }

  const handleIntegrationClick = () => {
    const userType = auth.getUserTypeAgent();
    let shouldRedirect = false;

    if (userType === "Super") {
      if (voicePermissionAdmin === "Yes") {
        if (integrationInfo && integrationInfo.length > 0) {
          if (integrationInfo[0]["enable"] === "Yes") {
            shouldRedirect = true;
          }
        }
      }
    } else if (userType === "Sub") {
      if (voicePermissionAdmin === "Yes") {
        if (
          integrationInfo &&
          integrationInfo.length > 0 &&
          parentIntegration &&
          parentIntegration.length > 0
        ) {
          if (
            integrationInfo[0]["enable"] === "Yes" &&
            parentIntegration[0]["enable"] === "Yes"
          ) {
            shouldRedirect = true;
          }
        }
      }
    }


    if (shouldRedirect) {
      handleRedirect();
    }
  };

  const handleRedirect = () => {
    let accountno = auth.getAccount();
    let parent_accountno = auth.getParentAcct();
    let email = auth.getEmail();
    let firstName = auth.getName();
    let compName = auth.getCompName();
    let userType = auth.getUserTypeAgent();

    let address =
      clientData && clientData.length > 0 ? clientData[0].address : "";
    let title = clientData && clientData.length > 0 ? clientData[0].title : "";
    let phone = clientData && clientData.length > 0 ? clientData[0].phone : "";
    let country =
      clientData && clientData.length > 0 ? clientData[0].country : "";
    let city = clientData && clientData.length > 0 ? clientData[0].city : "";
    let zip = clientData && clientData.length > 0 ? clientData[0].zip : "";
    let state = clientData && clientData.length > 0 ? clientData[0].state : "";
    let account_status =
      clientData && clientData.length > 0 ? clientData[0].account_status : "";

    // Extract OCN from integrationInfo
    let ocn =
      integrationInfo && integrationInfo.length > 0 && integrationInfo[0].ocn
        ? integrationInfo[0].ocn
        : "";

    let return_url = `${
      process.env.REACT_APP_LIVE_URL
    }${auth.getResellerRegToken()}/client`;
    let status = account_status === "active" ? 1 : 0;

    const urlParams = new URLSearchParams(window.location.search);
    const directsso = urlParams.get("directsso");

    let tokenData = {
      accountno,
      email,
      firstName,
      compName,
      userType,
      status,
      title,
      phone,
      address,
      city,
      state,
      zip,
      country,
      ocn,
      return_url,
    };

    if (directsso === "yes") {
      tokenData.isDirectSSO = 1;
    }

    if (userType === "Sub") {
      tokenData.parent_accountno = parent_accountno;
    }

    const tokenDataString = JSON.stringify(tokenData);

    const secretKey = process.env.REACT_APP_CARRIER_VOICE_ALERTS_SECRET_KEY;
    const encryptedToken = pythonEncrypt(tokenDataString, secretKey);
    const baseUrl = process.env.REACT_APP_CARRIER_VOICE_ALERTS_URL;
    const url = `${encryptedToken}`;
    window.location.replace(`${baseUrl}${url}`);
  };

  const pythonEncrypt = (data, passphrase) => {
    const secretKey = CryptoJS.enc.Hex.parse(passphrase);
    const iv = CryptoJS.lib.WordArray.random(16);

    const encrypted = CryptoJS.AES.encrypt(data, secretKey, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    // Concatenate raw IV + ciphertext (in binary form)
    const rawIv = iv;
    const rawCiphertext = CryptoJS.enc.Base64.parse(encrypted.toString());

    const combined = rawIv.concat(rawCiphertext);

    const base64Encoded = CryptoJS.enc.Base64.stringify(combined);

    return base64Encoded
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "");
  };

  // helper inside Header component
  const canShowPrivateIntegration = () => {
    const userType = auth.getUserTypeAgent();

    if (userType === "Super") {
      return (
        voicePermissionAdmin === "Yes" &&
        integrationInfo?.length > 0 &&
        integrationInfo[0]?.enable === "Yes"
      );
    }

    if (userType === "Sub") {
      return (
        voicePermissionAdmin === "Yes" &&
        integrationInfo?.length > 0 &&
        parentIntegration?.length > 0 &&
        integrationInfo[0]?.enable === "Yes" &&
        parentIntegration[0]?.enable === "Yes"
      );
    }

    return false;
  };


  return (
    <>
      {showExpiryModal && (
        <div
          className="modal fade show"
          onClick={handleModalBackdropClick}
          style={{
            display: "block",
            backgroundColor: "rgba(0, 0, 0, 0.4)",
            zIndex: 1050,
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
          }}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            onClick={(e) => e.stopPropagation()}
            style={{ maxWidth: "520px", width: "100%", margin: "auto" }}
          >
            <div
              className="modal-content"
              style={{
                borderRadius: "12px",
                border: "none",
                boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
              }}
            >
              {/* Header */}
              <div
                className="modal-header"
                style={{
                  padding: "1rem 1.25rem",
                  borderBottom: "1px solid #e5e7eb",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <h5
                  className="modal-title"
                  style={{
                    margin: 0,
                    fontWeight: 600,
                    fontSize: "1.125rem",
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                    color: "#364a63",
                  }}
                >
                  <em className="icon ni ni-alert-circle" />
                  Session Expiring Soon
                </h5>
                <div
                  onClick={() => handleCloseModal()}
                  className="modal-close-button"
                  style={{
                    cursor: "pointer",
                    padding: "6px",
                    borderRadius: "6px",
                    transition: "background 0.2s",
                  }}
                  title="Close"
                >
                  <em
                    className="icon ni ni-cross"
                    style={{ fontSize: "20px", color: "#6b7280" }}
                  />
                </div>
              </div>

              {/* Body */}
              <div
                className="modal-body"
                style={{
                  padding: "1.75rem 2rem",
                  textAlign: "center",
                  backgroundColor: "#fff",
                }}
              >
                {errorMessage && (
                  <div className="example-alert mb-3">
                    <div className="alert alert-pro alert-danger">
                      <div className="alert-text">
                        <h4>Error</h4>
                        <p>{errorMessage}</p>
                      </div>
                    </div>
                  </div>
                )}
                {successMessage && (
                  <div className="example-alert mb-3">
                    <div className="alert alert-pro alert-success">
                      <div className="alert-text">
                        <h4>Success</h4>
                        <p>{successMessage}</p>
                      </div>
                    </div>
                  </div>
                )}

                <em
                  className="icon ni ni-clock"
                  style={{
                    fontSize: "2.5rem",
                    color: "#364a63",
                    marginBottom: "1rem",
                    display: "block",
                  }}
                ></em>

                <p
                  style={{
                    fontSize: "1rem",
                    marginBottom: "0.5rem",
                    color: "#374151",
                  }}
                >
                  Your session will expire in:
                </p>
                <h4
                  style={{
                    fontSize: "1.75rem",
                    fontWeight: 700,
                    color: "#dc2626",
                    marginBottom: "1rem",
                  }}
                >
                  {timeLeft ? formatTime(timeLeft) : "0s"}
                </h4>

                <p
                  style={{
                    color: "#6b7280",
                    fontSize: "0.95rem",
                    marginBottom: "1rem",
                  }}
                >
                  Do you want to stay signed in and extend your session?
                </p>

                <div
                  className="alert alert-warning"
                  style={{
                    backgroundColor: "#fef3c7",
                    borderColor: "#fde68a",
                    color: "#92400e",
                    borderRadius: "6px",
                    padding: "12px",
                    fontSize: "0.875rem",
                  }}
                >
                  <strong>Note:</strong> You will be automatically logged out if
                  no action is taken.
                </div>
              </div>

              {/* Footer */}
              <div
                className="modal-footer"
                style={{
                  padding: "1rem 2rem",
                  borderTop: "1px solid #e5e7eb",
                  backgroundColor: "#f9fafb",
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "0.75rem",
                  borderBottomLeftRadius: "12px",
                  borderBottomRightRadius: "12px",
                }}
              >
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => {
                    setShowExpiryModal(false);
                    auth.logout();
                  }}
                >
                  <em className="icon ni ni-signout mr-1"></em>
                  Sign Out
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={extendSession}
                  disabled={isExtending}
                >
                  {isExtending ? (
                    <>
                      <div
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        style={{
                          width: "1rem",
                          height: "1rem",
                          marginRight: "8px",
                        }}
                      >
                        <span className="visually-hidden"></span>
                      </div>
                    </>
                  ) : (
                    <>
                      <em className="icon ni ni-reload mr-1"></em>
                      Extend Session
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="nk-header nk-header-fixed is-light">
        <div className="container-fluid">
          <div className="nk-header-wrap">
            <div className="nk-menu-trigger d-xl-none ml-n1">
              <a
                className="nk-nav-toggle nk-quick-nav-icon"
                data-target="sidebarMenu"
              >
                <em
                  className="icon ni ni-menu"
                  onClick={() => {
                    if (props.isOnboarding && props.onToggleMobileStepper) {
                      props.onToggleMobileStepper();
                    } else {
                      classCheck();
                    }
                  }}
                ></em>
              </a>
            </div>

            <div className="nk-header-brand ">
              <a href="/" className="logo-link">
                <img
                  className="logo-light logo-img"
                  src={auth.getResellerLogo()}
                  alt="logo"
                />
                <img
                  className="logo-dark logo-img"
                  src={auth.getResellerLogo()}
                  alt="logo-dark"
                />
              </a>
            </div>
            <div className="nk-header-tools">
              <ul className="nk-quick-nav">
                {timeLeft !== null && timeLeft <= 600000 && (
                  <li className="session-timer-container">
                    <div
                      className="session-timer"
                      style={{
                        cursor: timeLeft <= 600000 ? "pointer" : "default",
                        padding: "8px 12px",
                        background: timeLeft <= 600000 ? "#ffe6e6" : "#f8f9fa",
                        border: `1px solid ${
                          timeLeft <= 600000 ? "#ff9999" : "#dee2e6"
                        }`,
                        borderRadius: "6px",
                        fontSize: "12px",
                        fontWeight: "500",
                        color: timeLeft <= 600000 ? "#d32f2f" : "#666",
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                      }}
                      onClick={() => {
                        if (timeLeft <= 600000) {
                          localStorage.removeItem("modalClosedManually");
                          setShowExpiryModal(true);
                        }
                      }}
                      title={
                        timeLeft <= 600000 ? "Click to extend session" : ""
                      }
                    >
                      <em
                        className="icon ni ni-clock"
                        style={{ fontSize: "14px" }}
                      />
                      <span>Session: {formatTime(timeLeft)}</span>
                    </div>
                  </li>
                )}
                {/*<li className="contact_support_button">
                <button
                  type="button"
                  className="btn btn-dark"
                  onClick={props.modalContactAgent}
                >
                  <em className="icon ni ni-emails"></em>
                  <span>Contact Agent</span>{" "}
                </button>
              </li>*/}

                {/* Grid/Integrations Dropdown - Simplified */}
                {integrations.length > 0 && canShowPrivateIntegration() && (
                  <li className="dropdown integrations-dropdown">
                    <a
                      href="#"
                      className="dropdown-toggle nk-quick-nav-icon"
                      data-toggle="dropdown"
                    >
                      <em
                        className="icon ni ni-grid-box-alt-fill"
                        style={{ fontSize: "1.2rem" }}
                      ></em>
                    </a>
                    <div
                      className="dropdown-menu dropdown-menu-lg dropdown-menu-right dropdown-menu-s1"
                      style={{ minWidth: "320px" }}
                    >
                      <div className="dropdown-inner">
                        <div
                          className="dropdown-body"
                          style={{ maxHeight: "400px", overflowY: "auto" }}
                        >
                          {integrationLoader ? (
                            <div className="text-center p-4">
                              <div
                                className="spinner-border spinner-border-sm"
                                role="status"
                              >
                                <span className="sr-only">Loading...</span>
                              </div>
                            </div>
                          ) : (
                            <ul className="link-list" style={{ margin: 0 }}>
                              {integrations.map((integration, index) => {
                                return (
                                  <li
                                    key={integration.id || index}
                                    style={{ marginBottom: "8px" }}
                                  >
                                    <button
                                      type="button"
                                      onClick={handleIntegrationClick}
                                      style={{
                                        display: "block",
                                        padding: "12px 16px",
                                        border: "1px solid #e5e7eb",
                                        borderRadius: "8px",
                                        background: "white",
                                        textDecoration: "none",
                                        transition: "box-shadow 0.2s ease",
                                        boxShadow:
                                          "0 1px 2px rgba(0, 0, 0, 0.03)",
                                        width: "100%",
                                        textAlign: "left",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "space-between",
                                        }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            flex: 1,
                                          }}
                                        >
                                          <img
                                            src={`../../assets/images/${integration.integration_img}`}
                                            alt={integration.integration_title}
                                            style={{
                                              width: "36px",
                                              height: "36px",
                                              borderRadius: "8px",
                                              border: "2px solid #fff",
                                              boxShadow:
                                                "0 2px 6px rgba(0,0,0,0.06)",
                                              marginRight: "12px",
                                              objectFit: "contain", // keep aspect ratio
                                              backgroundColor: "#fff", // optional: prevent transparent edges from showing badly
                                            }}
                                            onError={(e) => {
                                              e.target.src =
                                                "/assets/images/integrations/default.png";
                                            }}
                                          />

                                          <span
                                            style={{
                                              fontWeight: "600",
                                              fontSize: "14px",
                                              color: "#111827",
                                            }}
                                          >
                                            {integration.integration_title}
                                          </span>
                                        </div>

                                        <em
                                          className="icon ni ni-arrow-right"
                                          style={{
                                            color: "#9ca3af",
                                            fontSize: "16px",
                                            opacity: 0.8,
                                          }}
                                        ></em>
                                      </div>
                                    </button>
                                  </li>
                                );
                              })}
                            </ul>
                          )}
                        </div>
                      </div>
                    </div>
                  </li>
                )}

                <li className="dropdown user-dropdown">
                  <a
                    href="#"
                    className="dropdown-toggle"
                    data-toggle="dropdown"
                  >
                    <div className="user-toggle">
                      <div className="user-avatar sm">
                        <em className="icon ni ni-user-alt"></em>
                      </div>
                      <div className="user-info d-none d-md-block">
                        <div className="user-status">{auth.getName()}</div>
                        <div className="user-name dropdown-indicator">
                          {auth.getCompName()}
                        </div>
                      </div>
                    </div>
                  </a>
                  <div className="dropdown-menu dropdown-menu-md dropdown-menu-right dropdown-menu-s1">
                    <div className="dropdown-inner user-card-wrap bg-lighter d-none d-md-block">
                      <div className="user-card">
                        <div className="user-avatar">
                          <span>{auth.getCompName().substring(0, 2)}</span>
                        </div>
                        <div className="user-info">
                          <span className="lead-text">
                            {auth.getCompName()}
                          </span>
                          <span className="sub-text">{auth.getEmail()}</span>
                        </div>
                      </div>
                    </div>
                    <div className="dropdown-inner">
                      <ul className="link-list">
                        <li>
                          <a
                            onClick={props.modalOpen}
                            style={{
                              cursor: "pointer",
                            }}
                          >
                            <em className="icon ni ni-user-alt"></em>
                            <span>View Profile</span>
                          </a>
                        </li>
                        {auth.getUserTypeAgent() !== "Sub" ? (
                          <li>
                            <a style={{ cursor: "pointer" }} href="/agents">
                              <em className="icon ni ni-user-list"></em>
                              <span>Sub Users</span>
                            </a>
                          </li>
                        ) : null}
                        <li>
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              props.modalLogin();
                            }}
                          >
                            <em className="icon ni ni-signin"></em>
                            <span>Login Details</span>
                          </a>
                        </li>
                        {/* <li>
                        <a
                          style={{ cursor: "pointer" }}
                          onClick={() => accountActivity()}
                        >
                          <em className="icon ni ni-list"></em>
                          <span>Account Activity</span>
                        </a>
                      </li> */}
                        {/*<li className="contact_support_button_reverse">
                        <a
                          style={{ cursor: "pointer" }}
                          onClick={props.modalContactAgent}
                        >
                          <em className="icon ni ni-emails"></em>
                          <span>Contact Agent</span>{" "}
                        </a>
                      </li>*/}
                      </ul>
                    </div>
                    <div className="dropdown-inner">
                      <ul className="link-list">
                        <li
                          onClick={() => auth.logout()}
                          style={{ cursor: "pointer" }}
                        >
                          <a>
                            <em className="icon ni ni-signout"></em>
                            <span>Sign out</span>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
